import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { textStyles } from '../../theme';
export default {
  container: {},
  wrapper: {
    maxWidth: function maxWidth(props) {
      var _props$theme;
      return "".concat((props == null ? void 0 : (_props$theme = props.theme) == null ? void 0 : _props$theme.maxWidth) / 10, "rem") || 'none';
    },
    marginLeft: 'auto',
    marginRight: 'auto',
    '& > * + *': {
      marginTop: '2.5rem'
    }
  },
  text: _objectSpread(_objectSpread({}, textStyles.text), {}, {
    textAlign: function textAlign(props) {
      var _props$theme2;
      return (props == null ? void 0 : (_props$theme2 = props.theme) == null ? void 0 : _props$theme2.paragraphTextAlign) || 'center';
    },
    '& > * + *': {
      marginTop: '0.5rem'
    }
  }),
  actions: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    '& > * + *': {
      marginLeft: '2.5rem'
    }
  }
};